import React from 'react';
import { SimpleGrid, SimpleGridProps } from '@hover/blueprint';

interface Props extends SimpleGridProps {}

const SectionWrapper: React.FC<Props> = ({ children, ...restProps }) => (
  <SimpleGrid
    columns={{ base: 1, desktop: 2 }}
    alignItems="center"
    spacing={{ base: 700, desktop: 900 }}
    {...restProps}
  >
    {children}
  </SimpleGrid>
);

export default SectionWrapper;
